/* eslint-disable sort-keys */
import * as NUMBER from 'constant/number'
import React from 'react'
import moment from 'moment'
import Organisations from 'view/component/organisations'
import Action from './action'
import Enabled from './enabled'

export const actionColumn = {
  key: 'action',
  render: user => {
    const action = <Action user={user} />
    return action
  },
  title: 'Action'
}

export const enabledColumn = {
  dataIndex: 'enabled',
  key: 'enabled',
  render: (enabled) => {
    const component = <Enabled enabled={enabled} />
    return component
  },
  title: 'Status'
}

export const loginTypeColumn = {
  dataIndex: 'login_type',
  key: 'login_type',
  render: ({ display_name: name }) => name.charAt(NUMBER.ZERO).toUpperCase() + name.slice(NUMBER.ONE),
  title: 'Login Type',
  width: 130
}

export const firstNameColumn = {
  dataIndex: 'first_name',
  key: 'first_name',
  sorter: true,
  title: 'First Name',
  width: 130
}

export const lastNameColumn = {
  dataIndex: 'last_name',
  key: 'last_name',
  sorter: true,
  title: 'Last Name',
  width: 130
}

export const emailColumn = {
  dataIndex: 'email',
  key: 'email',
  sorter: true,
  title: 'Email'
}

export const userTypeColumn = {
  dataIndex: 'user_type',
  key: 'user_type',
  render: ({ name }) => name,
  title: 'User Type',
  width: 130
}

export const organisationsColumn = {
  dataIndex: 'organisations',
  key: 'organisations',
  render: (organisations) => {
    const component = <Organisations organisations={organisations} />
    return component
  },
  title: 'Organisations',
  width: 400
}

export const createdColumn = {
  dataIndex: 'created',
  key: 'created',
  render: (timestamp) => moment(timestamp).format('DD/MM/YYYY'),
  title: 'Created'
}

export const userColumns = {
  action: actionColumn,
  status: enabledColumn,
  login_type: loginTypeColumn,
  first_name: firstNameColumn,
  last_name: lastNameColumn,
  email: emailColumn,
  user_type: userTypeColumn,
  organisations: organisationsColumn,
  created: createdColumn
}
